/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Domain} from './Domain';

/**
 * The PropertiesPropertyIdBody model module.
 * @module model/PropertiesPropertyIdBody
 * @version 1.0.0
 */
export class PropertiesPropertyIdBody {
  /**
   * Constructs a new <code>PropertiesPropertyIdBody</code>.
   * @alias module:model/PropertiesPropertyIdBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>PropertiesPropertyIdBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PropertiesPropertyIdBody} obj Optional instance to populate.
   * @return {module:model/PropertiesPropertyIdBody} The populated <code>PropertiesPropertyIdBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new PropertiesPropertyIdBody();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('shortcode'))
        obj.shortcode = ApiClient.convertToType(data['shortcode'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
      if (data.hasOwnProperty('domains'))
        obj.domains = Domain.constructFromObject(data['domains']);
    }
    return obj;
  }
}

/**
 * @member {String} title
 */
PropertiesPropertyIdBody.prototype.title = undefined;

/**
 * @member {String} shortcode
 */
PropertiesPropertyIdBody.prototype.shortcode = undefined;

/**
 * @member {String} description
 */
PropertiesPropertyIdBody.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
PropertiesPropertyIdBody.prototype.enabled = undefined;

/**
 * @member {module:model/Domain} domains
 */
PropertiesPropertyIdBody.prototype.domains = undefined;

